import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';

import investmentFilterLang from '../../../langs/investmentFilterLang';
import IFundReportingPeriod from '../../../../../interfaces/IFundReportingPeriod';
import langInvestWordLang from '../../../../../langs/langInvestWordLang';

type CFiltersReportingPeriodSelectProps = {
	optionsReportingPeriods: IFundReportingPeriod[];
	filters: IInvestExpertiseFilters;
	onChange: (filters: IInvestExpertiseFilters) => void;
};

const CFiltersReportingPeriodSelect = (props: CFiltersReportingPeriodSelectProps) => {
	const { optionsReportingPeriods, filters, onChange } = props;

	const { t } = useTranslation();

	return (
		<>
			{optionsReportingPeriods ? (
				<CAppFilterSelect
					className="filter-reportingPeriod"
					label={t(investmentFilterLang.quarter.tag)}
					value={(() => {
						const found =
							filters && filters.reportingPeriod
								? optionsReportingPeriods.find((x) => x.tag === filters.reportingPeriod)
								: undefined;
						return found
							? { id: found.tag, name: found.name }
							: {
									id: null,
									name:
										t(investmentFilterLang.value_as_of_today.tag) +
										' - ' +
										t(langInvestWordLang.estimated.tag),
							  };
					})()}
					onChange={(val: { id: string; name: string }) =>
						onChange({
							...filters,
							reportingPeriod: val ? val.id : null,
						})
					}
					size="small"
					options={optionsReportingPeriods.map((x) => ({ id: x.tag, name: x.name }))}
				/>
			) : (
				<></>
			)}
		</>
	);
};

export default CFiltersReportingPeriodSelect;
